import { HttpContextToken } from '@angular/common/http';

/** Default per-attempt timeout (ms) applied by HttpResilienceInterceptor to `/api` calls. */
export const DEFAULT_HTTP_TIMEOUT_MS = 30_000;

/** Maximum wait (ms) for an `/api` call to be dispatched, which covers sign-in token acquisition. */
export const DEFAULT_TOKEN_WAIT_TIMEOUT_MS = 60_000;

/**
 * Per-attempt timeout (in ms) honoured by HttpResilienceInterceptor. Requests that
 * don't set it fall back to {@link DEFAULT_HTTP_TIMEOUT_MS}. Long-running calls
 * (e.g. Foundry agent chat) set a higher value via the request's HttpContext.
 */
export const HTTP_TIMEOUT_MS = new HttpContextToken<number>(() => DEFAULT_HTTP_TIMEOUT_MS);
